module.exports = __webpack_public_path__ + "img/logo_horizontal.0f03beb5.svg";